

<div class="questionFillingPanel">

	@if( dataInput && fGroup ) {

		<triv-input
			[fGroup]="fGroup"
			[data]="dataInput"
			[bAutoClean]="true"
		/>

	}

	@if( q.children.length ) {

		@for( child of q.children; track child.id; let i = $index ) {

			@if( q.bIsLoop && child.bIsVisible && !( i % (0 + q.children.length / fGroup.get( '' + dataInput?.id )?.value) ) ) {
				
				<div
					[@flyInOut]
					style="font-size: small; color: grey; margin-top: 1em;"
				>
					{{child.nInLoop}}:
				</div>

			}

			@if( child.bIsVisible ) {

				<!-- display: block for the animation -->
				<question
					[@flyInOut]
					style="display: block; margin-left: 30px;"
					[question]="child"
					[formGroup]="fGroup"
				/>

			}
			
		}
	
	}

</div>
